import { getSnapShot } from "@portal/api/snapshot";
import { useQuery } from "@tanstack/react-query";

function useSnapShotQuery() {
  return useQuery({
    queryKey: ["snapshot"],
    queryFn: () => getSnapShot(),
    retry: false,
    onError(err) {
      throw new Error(`${err}`);
    },
  });
}

export { useSnapShotQuery };
